/**
 * Created by eriksundqvist on 15/11/16.
 */
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { InvoiceService, TaxService, UserSettingsConstants } from 'frilans-finans';
import CalculatorPostEntity from '../../frilans-finans/calculator/calculator-post-entity';
import CalculatorWorkerEntity from '../../frilans-finans/calculator/calculator-worker-entity';
import { getVatById } from '../../views/invoice-tool/invoice-tool-helper';
import { toMoney } from '../../views/invoice-tool/amount/amount-helper';
import {
  setCurrencyAmount,
  setAmount,
  setLockAmountDistribution,
  setAmountIncVat,
  setInvoiceUser,
  setAmountAfterHsd
} from 'redux/modules/invoice/index';
import * as entities from 'selectors/entities';
var _ = require('lodash');

const CALCULATE_AMOUNT = 'calculate-amount';
const CALCULATE_AMOUNT_WITH_LOCKED_USERS = 'calculate-amount-with-locked-users';
const CALCULATE_SUPPLIER_LEDGE = 'calculate-supplier-ledge';
const CALCULATE_SUPPLIER_LEDGE_WITH_LOCKED_USERS = 'calculate-supplier-ledge-with-locked-users';
const CALCULATE_INVOICE_USER_LOCKED_AMOUNT = 'calculate-invoice-user-locked-amount';
const CALCULATE_INVOICE_USER_AMOUNT = 'calculate-invoice-user-amount';
const CALCULATE_INVOICE_USER_GROSS_SALARY = 'calculate-invoice-user-gross-salary';
const CALCULATE_INVOICE_USER_NET_SALARY = 'calculate-invoice-user-net-salary';
const CALCULATE_INVOICE_USER_ALLOWANCE = 'calculate-invoice-user-allowance';
const CALCULATE_INVOICE_USER_TRAVEL = 'calculate-invoice-user-travel';
const CALCULATE_INVOICE_USER_TAX = 'calculate-invoice-user-tax';
const CALCULATE_INVOICE_USER_ADD_REMOVE = 'calculate-invoice-user-add-remove';
const CALCULATE_INVOICE_EXPRESS_PAYMENT = 'calculate-invoice-express-payment';
const CALCULATE_INVOICE_HSD = 'calculate-invoice-hsd';
const CALCULATE_INVOICE_ITP_VACATION_CHANGE = 'calculate_invoice_itp_vacation_change';
const CALCULATE_INVOICE_COUPON = 'calculate-invoice-coupon';
const CALCULATE_INVOICE_INITIALIZING = 'calculate-invoice-initializing';

const EXPRESS_PAYMENT_PERCENT = 1.5;

export class InvoiceCalculator extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired,
    currencies: PropTypes.object.isRequired,
    supplierLedgerTypes: PropTypes.array.isRequired,
    setLockAmountDistribution: PropTypes.func.isRequired,
    setCurrencyAmount: PropTypes.func.isRequired,
    setAmount: PropTypes.func.isRequired,
    setAmountIncVat: PropTypes.func.isRequired,
    setInvoiceUser: PropTypes.func.isRequired,
    setAmountAfterHsd: PropTypes.func.isRequired
  };

  static updatedWorker;

  constructor (props) {
    super(props);

    this.state = {
      justUpdated: null,
      disableCalculation: false
    };

    this.calculate = this.calculate.bind(this);
    this.parseCalculationResponse = this.parseCalculationResponse.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps, this.props) && !nextProps.invoice.initializing && !this.state.disableCalculation) {
      let updated;
      let value;

      this.updatedWorker = null;

      if (nextProps.invoice.invoiceUser.length !== this.props.invoice.invoiceUser.length &&
        nextProps.invoice.amount !== 0) {
        updated = CALCULATE_INVOICE_USER_ADD_REMOVE;
        value = nextProps.invoice.invoiceUser;
      }

      let lockAmountDistribution = nextProps.invoice.lockAmountDistribution;
      let lockAmountLength = Object.keys(lockAmountDistribution).length;

      if (!_.isEqual(nextProps.invoice.supplierLedger, this.props.invoice.supplierLedger)) {
        if (lockAmountLength === 0) {
          updated = CALCULATE_SUPPLIER_LEDGE;
        } else {
          updated = CALCULATE_SUPPLIER_LEDGE_WITH_LOCKED_USERS;
        }
        value = nextProps.invoice.amount;
      }

      if (nextProps.invoice.expressPayment !== this.props.invoice.expressPayment) {
        updated = CALCULATE_INVOICE_EXPRESS_PAYMENT;
        value = nextProps.invoice.amount;
      }

      if (nextProps.invoice.hsd.rot !== this.props.invoice.hsd.rot ||
        nextProps.invoice.hsd.rut !== this.props.invoice.hsd.rut) {
        updated = CALCULATE_INVOICE_HSD;
        value = nextProps.invoice.amount;
      }

      if (!_.isEqual(nextProps.invoice.coupon, this.props.invoice.coupon)) {
        updated = CALCULATE_INVOICE_COUPON;
        value = nextProps.invoice.coupon;
      }

      if (nextProps.user.saveITP !== this.props.user.saveITP ||
        nextProps.user.saveVacationPay !== this.props.user.saveVacationPay) {
        updated = CALCULATE_INVOICE_ITP_VACATION_CHANGE;
        value = nextProps.user;
      }

      if (!updated) {
        if ((nextProps.invoice.amount !== this.props.invoice.amount && lockAmountLength === 0) ||
          nextProps.invoice.taxId !== this.props.invoice.taxId) {
          updated = CALCULATE_AMOUNT;
          value = nextProps.invoice.amount;
        } else if (nextProps.invoice.amount !== this.props.invoice.amount) {
          updated = CALCULATE_AMOUNT_WITH_LOCKED_USERS;
          value = nextProps.invoice.amount;
        }
      }

      if (!updated) {
        let user;

        for (let i = 0; i<nextProps.invoice.invoiceUser.length; i++) {
          user = nextProps.invoice.invoiceUser[i];
          let prevUser;
          for (let i = 0; i<this.props.invoice.invoiceUser.length; i++) {
            if (parseInt(user.userId) === parseInt(this.props.invoice.invoiceUser[i].userId)) {
              prevUser = this.props.invoice.invoiceUser[i];
              break;
            }
          }

          if (user && prevUser) {
            if (toMoney(user.gross) !== toMoney(prevUser.gross)) {
              updated = CALCULATE_INVOICE_USER_GROSS_SALARY;
            } else if (toMoney(user.net) !== toMoney(prevUser.net)) {
              updated = CALCULATE_INVOICE_USER_NET_SALARY;
            } else if (toMoney(user.allowance) !== toMoney(prevUser.allowance)) {
              updated = CALCULATE_INVOICE_USER_ALLOWANCE;
            } else if (toMoney(user.travel) !== toMoney(prevUser.travel)) {
              updated = CALCULATE_INVOICE_USER_TRAVEL;
            } else if (user.taxkeyId !== prevUser.taxkeyId) {
              updated = CALCULATE_INVOICE_USER_TAX;
            } else if ((toMoney(user.total) !== toMoney(prevUser.total) && lockAmountLength === 0)) {
              updated = CALCULATE_INVOICE_USER_AMOUNT;
            } else if (toMoney(user.total) !== toMoney(prevUser.total) && lockAmountLength > 0) {
              updated = CALCULATE_INVOICE_USER_LOCKED_AMOUNT;
            }

            if (updated) {
              this.updatedWorker = user.userId;
              break;
            } else {
              this.updatedWorker = null;
            }
          }
        }

        value = user;
      }

      if (!updated) {
        if (this.props.invoice.initializing) {
          updated = CALCULATE_INVOICE_INITIALIZING;
        }
      }

      if (updated) {
        this.calculate(updated, value, nextProps);
      }
    }
  }

  populateCalculatorWorkerEntity (invoiceUser, updated, value, nextProps) {
    let userData = invoiceUser;
    if (value && value.userId && invoiceUser.userId === value.userId) {
      userData = value;
    }

    let calculatorWorkerEntity = new CalculatorWorkerEntity();
    calculatorWorkerEntity.gross = null;
    calculatorWorkerEntity.net = null;
    calculatorWorkerEntity.amount = null;

    let userId = this.updatedWorker;

    if (userId === invoiceUser.userId) {
      switch (updated) {
        case CALCULATE_INVOICE_USER_GROSS_SALARY:
          calculatorWorkerEntity.gross = +userData.gross;
          break;
        case CALCULATE_INVOICE_USER_NET_SALARY:
          calculatorWorkerEntity.net = +userData.net;
          break;
        case CALCULATE_INVOICE_USER_LOCKED_AMOUNT:
        case CALCULATE_INVOICE_USER_AMOUNT:
        case CALCULATE_INVOICE_USER_ALLOWANCE:
        case CALCULATE_INVOICE_USER_TRAVEL:
        case CALCULATE_INVOICE_USER_TAX:
          calculatorWorkerEntity.amount = +userData.total;
          break;
      }
    } else if (nextProps.invoice.lockAmountDistribution[parseInt(invoiceUser.userId)]) {
      calculatorWorkerEntity.amount = +userData.total;
    } else if (_.includes([
      CALCULATE_INVOICE_INITIALIZING,
      CALCULATE_INVOICE_COUPON,
      CALCULATE_INVOICE_EXPRESS_PAYMENT,
      CALCULATE_INVOICE_ITP_VACATION_CHANGE,
      CALCULATE_INVOICE_HSD,
      CALCULATE_SUPPLIER_LEDGE,
      CALCULATE_SUPPLIER_LEDGE_WITH_LOCKED_USERS,
      CALCULATE_INVOICE_USER_ALLOWANCE,
      CALCULATE_INVOICE_USER_TRAVEL,
      CALCULATE_INVOICE_USER_TAX
    ], updated)) {
      calculatorWorkerEntity.amount = userData.total;
    }
    let itp = !!userData.saveItp;
    let itpRate = (userData.itpRate === undefined) ? UserSettingsConstants.itpRateDefault : userData.itpRate;

    let vacation = !!userData.saveVacationPay;

    if (parseInt(userData.userId) === parseInt(this.props.user.id)) {
      if (updated === CALCULATE_INVOICE_ITP_VACATION_CHANGE) {
        itp = value.saveITP;
        itpRate = value.itpRate;
        vacation = value.saveVacationPay || false;
      } else {
        itp = this.props.user.saveITP;
        itpRate = this.props.user.itpRate;
        vacation = this.props.user.saveVacationPay || false;
      }
    }

    let taxKey;
    taxKey = userData.taxkeys.find(taxkey => {
      return +taxkey.id === +userData.taxkeyId;
    });

    if (!taxKey) {
      // Set to default taxkey if the taxkey wasn't found
      taxKey = userData.taxkeys.find(taxkey => {
        return +taxkey.id === +nextProps.user.defaultTaxkeyId;
      });
    }

    calculatorWorkerEntity.id = userData.userId;
    calculatorWorkerEntity.itp = itp;
    calculatorWorkerEntity.itp_rate = itpRate;
    calculatorWorkerEntity.vacation = vacation;
    calculatorWorkerEntity.allowance = userData.allowance;
    calculatorWorkerEntity.travel = userData.travel;
    calculatorWorkerEntity.payroll_tax = taxKey ? taxKey.payrollTax : null;

    if (nextProps.invoice.expressPayment) {
      calculatorWorkerEntity.fee = taxKey ? taxKey.feeExpress : null;
    } else {
      calculatorWorkerEntity.fee = taxKey ? taxKey.fee : null;
    }

    const extraFee = nextProps.invoice.expressPayment ? EXPRESS_PAYMENT_PERCENT : 0;
    if (updated === CALCULATE_INVOICE_COUPON && value) {
      calculatorWorkerEntity.fee = value.discountValue + extraFee;
    } else if (nextProps.invoice.coupon) {
      calculatorWorkerEntity.fee = nextProps.invoice.coupon.discountValue + extraFee;
    }

    calculatorWorkerEntity.tax = taxKey ? taxKey.taxAmount : null;

    return calculatorWorkerEntity;
  }

  calculate (updated, value, nextProps) {
    let calculatorPostEntity = new CalculatorPostEntity();
    if (!nextProps.invoice.taxId) {
      return;
    }

    calculatorPostEntity.vat = getVatById(nextProps.invoice.taxId);

    let allInvoiceUser = nextProps.invoice.invoiceUser;
    if (updated === CALCULATE_INVOICE_USER_ADD_REMOVE) {
      allInvoiceUser = _.map(value, (user) => {
        return Object.assign({}, user);
      });
    }

    let workers = [];

    const sortedInvoiceUsers = [
      ...allInvoiceUser.filter(({userId}) => +userId === +nextProps.invoice.userId),
      ...allInvoiceUser.filter(({userId}) => +userId !== +nextProps.invoice.userId)
    ];

    for (let i = 0; i<sortedInvoiceUsers.length; i++) {
      workers.push(
        this.populateCalculatorWorkerEntity(
          sortedInvoiceUsers[i],
          updated,
          value,
          nextProps
        )
      );
    }

    calculatorPostEntity.workers = workers;

    if (this.allWorkerAmountsSet(calculatorPostEntity)) {
      calculatorPostEntity.amount = null;
    } else {
      calculatorPostEntity.amount = nextProps.invoice.amount;
    }

    calculatorPostEntity.rot = nextProps.invoice.hsd.rot;
    calculatorPostEntity.rut = nextProps.invoice.hsd.rut;

    this.setState({
      justUpdated: updated
    });

    if (this.workerAmountOrInvoiceAmountSet(calculatorPostEntity)) {
      // We need the taxes to get the correct VAT for each expense
      if (nextProps.invoice.supplierLedger.length > 0) {
        TaxService.get()
          .then((taxes) => {
            calculatorPostEntity.expenses = this.getExpenses(nextProps.invoice.supplierLedger, taxes);
            InvoiceService.getInvoiceCalculation(calculatorPostEntity)
              .then(this.parseCalculationResponse);
          });
      } else {
        InvoiceService.getInvoiceCalculation(calculatorPostEntity)
          .then(this.parseCalculationResponse);
      }
    } else {
      console.log('Ignored calculate request');
    }
  }

  countWorkersSet (workers, notNullOnly = false) {
    let workerAmountsSet = 0;

    workers.forEach((worker) => {
      if (this.checkValueOrNotNull(worker.amount, notNullOnly) ||
          this.checkValueOrNotNull(worker.net, notNullOnly) ||
          this.checkValueOrNotNull(worker.gross, notNullOnly)) {
        workerAmountsSet++;
      }
    });

    return workerAmountsSet;
  }

  checkValueOrNotNull (value, notNullOnly = false) {
    if (notNullOnly) {
      return value !== null;
    }

    return value && value !== null;
  }

  allWorkerAmountsSet (calculatorPostEntity) {
    return calculatorPostEntity.workers.length === this.countWorkersSet(calculatorPostEntity.workers, true);
  }

  workerAmountOrInvoiceAmountSet (calculatorPostEntity) {
    let invoiceAmountIsSet = typeof calculatorPostEntity.amount !== 'undefined' && calculatorPostEntity.amount !== null;
    return invoiceAmountIsSet || this.countWorkersSet(calculatorPostEntity.workers) > 0;
  }

  getExpenses (supplierLedgers, taxes) {
    let expenses = [];

    for (let s of supplierLedgers) {
      let vat = 0;
      let amount = s.amount;

      for (let t of taxes) {
        if (parseInt(t.id) === parseInt(s.taxId)) {
          vat = t.percent;
        }
      }

      const supplierLedgerType = this.props.supplierLedgerTypes.find((type) => {
        return parseInt(type.id) === parseInt(s.supplierLedgerTypeId);
      });

      expenses.push({
        amount: amount,
        vat: vat,
        rot: supplierLedgerType.isRotRut,
        rut: supplierLedgerType.isRotRut
      });
    }

    return expenses;
  }

  parseCalculationResponse (response) {
    if (!response) {
      return;
    }

    this.setState({
      disableCalculation: true
    });

    let invoiceUser = _.map(this.props.invoice.invoiceUser, (user) => {
      return Object.assign({}, user);
    });

    let totalInvoiceAmount = 0;
    for (let i = 0; i<invoiceUser.length; i++) {
      let userId = parseInt(invoiceUser[i].userId);
      let calculation;
      for (let j = 0; j<response.invoiceCalculations.length; j++) {
        if (userId === parseInt(response.invoiceCalculations[j].userId)) {
          calculation = response.invoiceCalculations[i];
          break;
        }
      }

      if (!calculation) {
        calculation = {};
        calculation.amount = 0;
        calculation.gross = 0;
        calculation.net = 0;
        calculation.allowance = 0;
        calculation.tax = 0;
        calculation.travel = 0;
        calculation.toPay = 0;
      }

      invoiceUser[i].calculation = calculation;
      invoiceUser[i].total = calculation.amount;

      invoiceUser[i].net = calculation.net;
      invoiceUser[i].gross = calculation.gross;
      invoiceUser[i].allowance = calculation.allowance;
      invoiceUser[i].travel = calculation.travel;

      for (let taxkey of invoiceUser[i].taxkeys) {
        if (parseInt(taxkey.id) === parseInt(invoiceUser[i].taxkeyId)) {
          invoiceUser[i].taxkeyName = taxkey.taxkeyName;
        }
      }
    }

    totalInvoiceAmount = Number(+(response.amount));

    this.props.setInvoiceUser(invoiceUser);
    this.props.setAmount(totalInvoiceAmount);

    const currentExchangeRate = entities.selectById(this.props.currencies.list,
      this.props.invoice.currencyId).exchangeRate;
    const currencyAmount = totalInvoiceAmount / (currentExchangeRate || 1);
    this.props.setCurrencyAmount(currencyAmount);

    this.props.setAmountIncVat(response.amountIncludingVat);
    this.props.setAmountAfterHsd(response.amountAfterHsd);

    this.setState({
      disableCalculation: false
    });
  }

  render () {
    return (
      <div></div>
    );
  }
}

function mapStateToProps (state) {
  return {
    user: state.user,
    invoice: state.invoice,
    currencies: state.currencies,
    supplierLedgerTypes: state.supplierLedgerTypes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLockAmountDistribution: (lockAmountDistribution) =>
      dispatch(setLockAmountDistribution(lockAmountDistribution)),
    setCurrencyAmount: (currencyAmount) =>
      dispatch(setCurrencyAmount(currencyAmount)),
    setAmount: (amount) =>
      dispatch(setAmount(amount)),
    setAmountIncVat: (amountIncVat) =>
      dispatch(setAmountIncVat(amountIncVat)),
    setInvoiceUser: (invoiceUser) =>
      dispatch(setInvoiceUser(invoiceUser)),
    setAmountAfterHsd: (amountAfterHsd) =>
      dispatch(setAmountAfterHsd(amountAfterHsd))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceCalculator);



/** WEBPACK FOOTER **
 ** ./src/components/invoice-calculator/invoice-calculator.js
 **/